import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as RB from 'react-bootstrap';

import { Link, RouteComponentProps, Redirect } from 'react-router-dom';
import * as DTO from '../service/DTOs';
import * as TF from '../service/tradeflow';
import * as Actions from '../service/Actions';
import * as Dispatch from '../service/Dispatcher';
import * as Intl from 'react-intl'
import { FilterSettings } from '../components/FilterSettings';
import { DoMRowContextLimits, initialState_DoMRowContextLimits } from '../components/DoMRowContextLimits';
import moment from 'moment';
import 'isomorphic-fetch';

import { SpinnerBlock } from './shared/effects/Spinners'
const iconSpinner = <SpinnerBlock />


interface DoMState {
    iheader: DTO.InstrumentHead;
    //iavail: DTO.InstrumentAvailabilityDto;
    bookorders: DTO.DomRecord[];
    loading: boolean;
    syshdr?: DTO.SystemHeader;
    processing?: boolean;
    selected_locatorId?: string;
    holdFocus: boolean;
    isFilterPanelVisible?: boolean;
    isContextLimitsPanelVisible?: boolean;
    context_record?: DTO.DomRecord;
}

type DoMProps = DoMState & { xsrfToken?: string } & { tradesession?: DTO.TradeSessionDto; } & { filterDS: DTO.AgentDSInstrumentFilter } & RouteComponentProps<{}>;

const initialstate: DoMState = {
    iheader: {
        id: 0, fiid: '0', name: '', pos: 0, currency: { id: 0, name: '', shortname: '' }, duration: { id: 0, name: '' },
        iavail: { fiid: '0', perms: [], readonly: false, suspended: false, tradeopen: false }
    },
    //iavail: { fiid: '0', perms: [], readonly: false, suspended: false, tradeopen: false },
    bookorders: [],
    loading: true,
    processing: false,
    holdFocus: false,
    isFilterPanelVisible: false,
    isContextLimitsPanelVisible: false
}



export class DoMComponent extends React.Component<DoMProps, DoMState> {
    _timeoutID: any;
    _cmpDoMRef: any;
    constructor(props: DoMProps) {
        super(props);
        this._cmpDoMRef = null;
        this.setCmpDoMRef = this.setCmpDoMRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.state = {
            ...initialstate, ...{ bookorders: props.bookorders, iheader: props.iheader, syshdr: props.syshdr }
        };
    }

    processInstrument(data: DTO.Instrument) {
        //console.log('setApiHeaderResponse call {' + data + '}');
        //console.log(data);
        //if (this.refs.cmpDoMRef) {

        //if (data.filter.fiid == '1') {
        //    console.log('processInstrument ' + data.filter.fiid);
        //    console.log(JSON.stringify(data.filter));
        //    console.log(JSON.stringify(this.props.filterDS));
        //}


        if (this._cmpDoMRef) {
            this.setState({
                iheader: data.header,
                bookorders: data.bookorders,
                loading: false,
                processing: !(JSON.stringify(data.filter) === JSON.stringify(this.props.filterDS))
            });
        }

        return { return: 0 };
    }

    //_onBlur() {
    //    console.log('_onBlur');
    //    this._timeoutID = setTimeout(() => {
    //        if (this.state.selected_locatorId) {
    //            this.setState({
    //                selected_locatorId: undefined,
    //            });
    //        }

    //        clearTimeout(this._timeoutID);
    //    }, 0);
    //}

    //_onFocus() {
    //    clearTimeout(this._timeoutID);
    //    if (!this.state.selected_locatorId) {
    //        this.setState({
    //            isManagingFocus: true,
    //        });
    //    }
    //}

    handleContextLimits(locatorId?: string, record?: DTO.DomRecord) {
        if (record) {
            this.setState({
                context_record: record
            });

            this.updateContextLimitsModal(true);
        }
    }

    handleSelectContext(locatorId?: string, record?: DTO.DomRecord) {
        this.setState({
            selected_locatorId: locatorId
        });


        let uiCtx: DTO.UserInteractionContext = {
            selected_cmp: this,
            selected_locatorId: locatorId
        }
        TF.PublishCommand('COMMAND.UI.UserInteractionCtx', uiCtx);

        //console.log('DoM headers props, state');
        //console.log(this.props.iheader);
        //console.log(this.state.iheader);

        if (locatorId && record) {
            let ins = Object.assign({}, this.state.iheader, { currency: this.props.iheader.currency }, { duration: this.props.iheader.duration });
            //console.log(ins);
            let cmd: TF.SelectDoMRecordCommand = {
                //instrument: { ...this.props.iheader, ...this.state.iheader},
                instrument: ins,
                record: record
            }

            TF.PublishCommand('COMMAND.SelectDoMRecord', cmd);
        }
    }

    setCmpDoMRef(element: any) {
        this._cmpDoMRef = element;
    }


    handleClickOutside(event: any) {
        if (this._cmpDoMRef && !this._cmpDoMRef.contains(event.target)) {
            this.setState({
                holdFocus: false,
            });
        }
        else {
            this.setState({
                holdFocus: true,
            });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidMount() {
        //(ReactDOM.findDOMNode(this.refs.toggleInput) as HTMLInputElement).bootstrapToggle('on');

        //var textInput = ReactDOM.findDOMNode(this.refs.toggleInput) as any;
        //console.log(textInput);
        //textInput.bootstrapToggle('on');


        //(ReactDOM.findDOMNode(this.refs.toggleInput)).bootstrapToggle('on');

        //$(this.refs.toggleInput.getDOMNode()).bootstrapToggle('on');
        document.addEventListener('mousedown', this.handleClickOutside);
        TF.DataProcessBinding(this, { type: 'DATA.updateinstrument', fiid: this.state.iheader.fiid, delegate: this.processInstrument });
        //this.setState({iheader: this.props.iheader});

        //console.log('DoM.componentDidMount');
    }


    _switchCaFilter = (newState: boolean) => {
        this.setState({ processing: true });

        let dsFilter: DTO.AgentDSInstrumentFilter = { ...this.props.filterDS, ...{ isContragentLimits: newState } };
        TF.PublishCommand('COMMAND.State.AgentDSInstrumentFilter', dsFilter);

        return {};
    }

    _switchSecFilter = (newState: boolean) => {
        this.setState({ processing: true });

        let dsFilter: DTO.AgentDSInstrumentFilter = { ...this.props.filterDS, ...{ isSecuritiesFilters: newState } };
        TF.PublishCommand('COMMAND.State.AgentDSInstrumentFilter', dsFilter);

        return {};
    }


    //getTrProps = {(state, rowInfo) => {
    //return {
    //    onClick: (e) => {
    //        this.setState({
    //            selected: rowInfo.index
    //        })
    //    },
    //    style: {
    //        background: rowInfo.index === this.state.selected ? '#00afec' : 'white',
    //        color: rowInfo.index === this.state.selected ? 'white' : 'black'
    //    }
    //}
    //}

    nextPath(path: string) {
        this.props.history.push(path);
    }

    updateFilterModal(isVisible: boolean) {
        this.setState({ isFilterPanelVisible: isVisible })
        //this.forceUpdate();

        if (!isVisible) {
            TF.PublishCommandForceAgentFrame();
        }
    }

    updateContextLimitsModal(isVisible: boolean) {
        this.setState({ isContextLimitsPanelVisible: isVisible })
        //this.forceUpdate();

        if (!isVisible) {
            TF.PublishCommandForceAgentFrame();
        }
    }

    public render() {
        //console.log(this.state.iheader);
        //<p><em>Processing...</em></p>
        let contents = this.state.loading
            ? <div>{iconSpinner}</div>
            : this.renderDoMTable(this.state.bookorders, this.state.processing ? this.state.processing : false);

        //<nav className="navbar navbar-default">
        //    <div className="container-fluid">
        //        <div className="navbar-header">
        //            <a href="#" className="navbar-brand">{this.state.iheader.name}</a>
        //        </div>
        //        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-2">
        //            <form className="navbar-form navbar-left">
        //                <div className="form-group">
        //                    <input className="form-control" placeholder="Search" />
        //                </div>
        //                <button type="submit" className="btn btn-default">Submit</button>
        //            </form>
        //        </div>

        //    </div>
        //</nav>


        //onBlur = { this._onBlur }
        //onFocus = { this._onFocus }

        let hdrContent = <div><b>{this.state.iheader.name}</b></div>
        var wellClass = (this.state.holdFocus ? 'well-selected' : '');
        var wellTitleClass = 'rep_welltitle';
        let suspendCover = undefined;
        if (this.state.iheader.iavail) {
            if (this.state.iheader.iavail.readonly) {
                wellTitleClass = wellTitleClass + ' readonly';
                hdrContent = <div><b>{this.state.iheader.name} {' [ReadOnly]'}</b></div>
            }
            if (!this.state.iheader.iavail.suspended && !this.state.iheader.iavail.tradeopen) {
                wellTitleClass = wellTitleClass + ' passive';
            }
            //if (this.state.iheader.iavail.suspended) 
            //    wellClass = wellClass + ' otc-coverdim';                
            if (this.state.iheader.iavail.suspended)
                suspendCover = <div className='otc-coverdim'>
                    <span>Торги приостановлены</span>
                </div>
        }
        else {
            wellTitleClass = wellTitleClass + ' passive';
        }


        let fliterContragent = this.props.filterDS.isContragentLimits ?
            <RB.Button bsStyle="success" title="Лимитный фильтр по контрагентам" onClick={this._switchCaFilter.bind(this, false)} disabled={this.state.processing}>
                <RB.Glyphicon glyph="ok" />{" "}{'КА-on'}
            </RB.Button>
            :
            <RB.Button bsStyle="default" title="Лимитный фильтр по контрагентам" onClick={this._switchCaFilter.bind(this, true)} disabled={this.state.processing}>
                <RB.Glyphicon glyph="minus" />{" "}{'КА-off'}
            </RB.Button>
            ;

        let fliterSecurities = this.props.filterDS.isSecuritiesFilters ?
            <RB.Button bsStyle="success" title="Лимитный фильтр по ЦБ" onClick={this._switchSecFilter.bind(this, false)} disabled={this.state.processing}>
                <RB.Glyphicon glyph="ok" />{" "}{'ЦБ-on'}
            </RB.Button>
            :
            <RB.Button bsStyle="default" title="Лимитный фильтр по ЦБ" onClick={this._switchSecFilter.bind(this, true)} disabled={this.state.processing}>
                <RB.Glyphicon glyph="minus" />{" "}{'ЦБ-off'}
            </RB.Button>
            ;

        let filterSettings = <RB.Modal className='menu-sidebar right' style={{ width: '500px' }} show={this.state.isFilterPanelVisible} onHide={() => this.updateFilterModal(false)} autoFocus keyboard>
            <RB.Modal.Header closeButton>
                <RB.Modal.Title>{'Настройки фильтров'}</RB.Modal.Title>
            </RB.Modal.Header>
            <RB.Modal.Body>
                <FilterSettings filterDS={this.props.filterDS} xsrfToken={this.props.xsrfToken} {...this.props} {...this.state} />
            </RB.Modal.Body>
        </RB.Modal>


        let contextLimitsSettings = <RB.Modal className='menu-sidebar right' style={{ width: '500px' }} show={this.state.isContextLimitsPanelVisible} onHide={() => this.updateContextLimitsModal(false)} autoFocus keyboard>
            <RB.Modal.Header closeButton>
                <RB.Modal.Title>{'Настройка лимитов'}</RB.Modal.Title>
            </RB.Modal.Header>
            <RB.Modal.Body>
                {this.state.context_record ?
                    <DoMRowContextLimits xsrfToken={this.props.xsrfToken} {...this.props} {...this.state} {...initialState_DoMRowContextLimits} instrument={this.props.iheader} domrecord={this.state.context_record} />
                    :
                    <span>{'Не выбран контекст'}</span>
                }
            </RB.Modal.Body>
        </RB.Modal>



        let showData = this.state.iheader.iavail ? (this.state.iheader.iavail.tradeopen || this.state.iheader.iavail.suspended ? true : false) : false;

        let wellFrame = <RB.Well bsSize="sm" className={wellClass} style={{ position: 'relative' }}>
            {suspendCover}
            <RB.ButtonToolbar className={wellTitleClass}>
                <RB.ButtonGroup bsSize="xsmall">
                    {hdrContent}
                </RB.ButtonGroup>

                <RB.ButtonGroup bsSize="xsmall">
                    <RB.Button title='Настроить фильтры' onClick={() => this.updateFilterModal(true)}><RB.Glyphicon glyph="filter" /></RB.Button>
                    {showData ? fliterContragent : ''}
                    {showData ? fliterSecurities : ''}
                </RB.ButtonGroup>
            </RB.ButtonToolbar>
            <div>{showData ? contents : <div className='table'></div>}</div>
        </RB.Well>


        // onBlur={this._onBlur}
        //onClick={() => this.nextPath('/settings')}
        return <div ref={this.setCmpDoMRef}>
            {filterSettings}
            {contextLimitsSettings}
            <RB.Row>
                <RB.Col sm={12}>
                    {wellFrame}
                </RB.Col>
            </RB.Row>
        </div>;

    }



    private renderDoMTable(orders: DTO.DomRecord[], processing: boolean) {
        return <table className='table table-header-fixed table-fix-H-200 table-condensed'>
            <thead>
                <tr style={{ width: 'calc(100% - 10px)' }}>
                    <th style={{ textAlign: 'right', width: '20%' }}>BUY</th>
                    <th style={{ textAlign: 'right', width: '25%' }}>сумма</th>
                    <th style={{ textAlign: 'right', width: '15%' }}>ставка</th>
                    <th style={{ textAlign: 'right', width: '25%' }}>сумма</th>
                    <th style={{ textAlign: 'right', width: '15%' }}>SELL</th>
                </tr>
            </thead>
            <tbody style={{ height: '240px' }}>
                {orders.map(domrecord =>
                    <DoMRecordRecord key={domrecord.manipulation.locatorId} record={domrecord} xsrfToken={this.props.xsrfToken} {...initialstate_domrecord} modified={domrecord.manipulation.justChanged ? domrecord.manipulation.justChanged : false}
                        processing={processing} domrecordSelected={this.handleSelectContext.bind(this)} selected={this.state.selected_locatorId == domrecord.manipulation.locatorId} holdFocus={this.state.holdFocus}
                        processContextLimits={this.handleContextLimits.bind(this)} tradesession={this.props.tradesession}
                    />
                )}
            </tbody>
        </table>;
    }
}


type DoMRecordProps = Actions.OrderState & { xsrfToken?: string } & { record: DTO.DomRecord }
    & { domrecordSelected: any } & { holdFocus: boolean }
    & { processContextLimits: (locatorId?: string, record?: DTO.DomRecord) => void; }
    & { tradesession?: DTO.TradeSessionDto; }
    ;

const initialstate_domrecord: Actions.OrderState = {
    processing: false,
    haserrors: false,
    modified: false,
    selected: false
}



class DoMRecordRecord extends React.Component<DoMRecordProps, Actions.OrderState> {
    constructor(props: DoMRecordProps) {
        super(props);
        this.state = {
            ...initialstate_domrecord, ...{ processing: props.processing, haserrors: props.haserrors, modified: props.modified }
        };
    }

    dispatch = (action: Actions.OrderAction) => {
        return Dispatch.OrderDispatcher(this, action);
    }


    _repeal = (locator: { locatorId: string } | undefined) => {
        //console.log('_repeal = ');
        //console.log(locator);

        let manipulation: DTO.ManipulationAction<string> = {
            //locatorType: DTO.MANIPULATION_LOCATOR_TYPE_LOOKUP,
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_REPEAL,
            locatorId: locator ? locator.locatorId : undefined,
            payload: undefined
        }

        return Actions.orderActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatch);
    }

    _context_limits = (locatorId: string, record: DTO.DomRecord) => {
        let manipulation: DTO.ManipulationAction<string> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_CONTEXT,
            locatorId: locatorId,
            payload: undefined
        }

        return this.props.processContextLimits(locatorId, record);
    }


    _onSelectRecord = (locatorId: string, record: DTO.DomRecord) => {
        return this.props.domrecordSelected(locatorId, record);
    }


    componentWillReceiveProps(nextProps: DoMRecordProps) {
        this.setState(nextProps);
    }


    public render() {

        //let bg_color = this.state.modified ? '#9be8d7' : (this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white'));
        let bg_color = this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white');
        //        let row_border = this.state.selected ? { borderStyle: 'solid', borderWidth: '2.5px' } : { borderStyle: 'none' };

        let crsr = this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_CONTEXT) ? { cursor: 'pointer' } : {};

        let animation_mod = this.state.modified ? { animation: 'newdata_blink_green 1s 10' } : {}

        let trStyle: React.CSSProperties = {
            //...{ backgroundColor: bg_color }, ...row_border, ...crsr
            ...{ textAlign: "right" }, ...{ backgroundColor: bg_color }, ...crsr, ...animation_mod
        };

        var trClass: string = (this.props.record.hasownedrecs ? 'owned-recs' : '') + ' ' + (this.state.selected && this.props.holdFocus ? 'rowselected' : (this.state.selected && !this.props.holdFocus ? 'rowonblur' : ''));
        //console.log(trClass);

        let recTime = moment(this.props.record.rectime).utc();
        let recordTimeCap = recTime.format('HH:mm:ss');

        let buylotsCap = this.props.record.buyminlots && this.props.record.buyminlots > 1 ? <span>{'/'}<Intl.FormattedNumber value={this.props.record.buyminlots} minimumFractionDigits={0} maximumFractionDigits={0} /></span >
            : undefined;

        let selllotsCap = this.props.record.sellminlots && this.props.record.sellminlots > 1 ? <span>{'/'}<Intl.FormattedNumber value={this.props.record.sellminlots} minimumFractionDigits={0} maximumFractionDigits={0} /></span >
            : undefined;

        let buyCap = this.props.record.buylots ?
            <span><Intl.FormattedNumber value={this.props.record.buylots} minimumFractionDigits={0} maximumFractionDigits={0} />{buylotsCap}</span>
            : '';

        let sellCap = this.props.record.selllots ?
            <span><Intl.FormattedNumber value={this.props.record.selllots} minimumFractionDigits={0} maximumFractionDigits={0} />{selllotsCap}</span>
            : '';

        let tillTime = this.props.tradesession ? TF.formatTimeInSessionCtx('Действует до: ', this.props.record.validtill, this.props.tradesession.sessionclose) : undefined;

        let validTill = tillTime ?
            <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
                <RB.Glyphicon glyph="time" title={tillTime} />
            </RB.ButtonGroup>
            :
            undefined;


        return <tr key={this.props.record.manipulation.locatorId} style={trStyle} onClick={this._onSelectRecord.bind(this, this.props.record.manipulation.locatorId, this.props.record)}
            className={trClass}>
            <td style={{ textAlign: 'right', width: '20%' }}>
                {this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_REPEAL) ?
                    <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
                        <RB.Button title='Снять свои заявки' disabled={this.state.processing}
                            onClick={this._repeal.bind(this, { locatorId: this.props.record.manipulation.locatorId })}><RB.Glyphicon glyph="remove" /></RB.Button>
                    </RB.ButtonGroup>
                    : ''
                }
                {this.props.record.buylots}
            </td>
            <td style={{ textAlign: 'right', width: '25%' }}>{this.props.record.buysum ? <Intl.FormattedNumber value={this.props.record.buysum} minimumFractionDigits={0} maximumFractionDigits={0} /> : ''}</td>
            <td style={{ textAlign: 'right', width: '15%' }}>{this.props.record.rate ? <Intl.FormattedNumber value={this.props.record.rate / 100.0} style="percent" minimumFractionDigits={2} maximumFractionDigits={2} /> : '-'} </td>
            <td style={{ textAlign: 'right', width: '25%' }}>{this.props.record.sellsum ? <Intl.FormattedNumber value={this.props.record.sellsum} minimumFractionDigits={0} maximumFractionDigits={0} /> : ''}</td>
            <td style={{ textAlign: 'right', width: '15%' }}>{this.props.record.selllots}
                {validTill}
            </td>
        </tr>


            ;
    }

}











//import * as React from 'react';
//import * as ReactDOM from 'react-dom';
//import * as RB from 'react-bootstrap';

//import { Link, RouteComponentProps, Redirect } from 'react-router-dom';
//import * as DTO from '../service/DTOs';
//import * as TF from '../service/tradeflow';
//import * as Actions from '../service/Actions';
//import * as Dispatch from '../service/Dispatcher';
//import * as Intl from 'react-intl'
//import { FilterSettings } from '../components/FilterSettings';

//import 'isomorphic-fetch';


//interface DoMState {
//    iheader: DTO.InstrumentHead;
//    //iavail: DTO.InstrumentAvailabilityDto;
//    bookorders: DTO.DomRecord[];
//    loading: boolean;
//    syshdr?: DTO.SystemHeader;
//    processing?: boolean;
//    selected_locatorId?: string;
//    holdFocus: boolean;
//    isFilterPanelVisible?: boolean;
//}

//type DoMProps = DoMState & { xsrfToken?: string } & { filterDS: DTO.AgentDSInstrumentFilter } & RouteComponentProps<{}>;

//const initialstate: DoMState = {
//    iheader: {
//        fiid: '0', name: '', pos: 0, currency: { id: 0, name: '', shortname: '' }, duration: { id: 0, name: '' },
//        iavail: { fiid: '0', perms: [], readonly: false, suspended: false, tradeopen: false }
//    },
//    //iavail: { fiid: '0', perms: [], readonly: false, suspended: false, tradeopen: false },
//    bookorders: [],
//    loading: true,
//    processing: false,
//    holdFocus: false,
//    isFilterPanelVisible: false
//}



//export class DoMComponent extends React.Component<DoMProps, DoMState> {
//    _timeoutID: any;
//    _cmpDoMRef: any;
//    constructor(props: DoMProps) {
//        super(props);
//        this._cmpDoMRef = null;
//        this.setCmpDoMRef = this.setCmpDoMRef.bind(this);
//        this.handleClickOutside = this.handleClickOutside.bind(this);
//        this.state = {
//            ...initialstate, ...{ bookorders: props.bookorders, iheader: props.iheader, syshdr: props.syshdr }
//        };
//    }

//    processInstrument(data: DTO.Instrument) {
//        //console.log('setApiHeaderResponse call {' + data + '}');
//        //console.log(data);
//        //if (this.refs.cmpDoMRef) {

//        //if (data.filter.fiid == '1') {
//        //    console.log('processInstrument ' + data.filter.fiid);
//        //    console.log(JSON.stringify(data.filter));
//        //    console.log(JSON.stringify(this.props.filterDS));
//        //}
        

//        if (this._cmpDoMRef) {
//            this.setState({
//                iheader: data.header,
//                bookorders: data.bookorders,
//                loading: false,
//                processing: !(JSON.stringify(data.filter) === JSON.stringify(this.props.filterDS) )
//            });
//        }

//        return { return: 0 };
//    }

//    //_onBlur() {
//    //    console.log('_onBlur');
//    //    this._timeoutID = setTimeout(() => {
//    //        if (this.state.selected_locatorId) {
//    //            this.setState({
//    //                selected_locatorId: undefined,
//    //            });
//    //        }

//    //        clearTimeout(this._timeoutID);
//    //    }, 0);
//    //}

//    //_onFocus() {
//    //    clearTimeout(this._timeoutID);
//    //    if (!this.state.selected_locatorId) {
//    //        this.setState({
//    //            isManagingFocus: true,
//    //        });
//    //    }
//    //}

//    handleSelectContext(locatorId?: string, record?: DTO.DomRecord) {
//        this.setState({
//            selected_locatorId: locatorId
//        });


//        let uiCtx: DTO.UserInteractionContext = {
//            selected_cmp: this,
//            selected_locatorId: locatorId
//        }

//        TF.PublishCommand('COMMAND.UI.UserInteractionCtx', uiCtx);

//        if (locatorId && record) {
//            let cmd: TF.SelectDoMRecordCommand = {
//                instrument: this.state.iheader,
//                record: record
//            }            

//            TF.PublishCommand('COMMAND.SelectDoMRecord', cmd);
//        }
//    }

//    setCmpDoMRef(element: any) {
//        this._cmpDoMRef = element;
//    }


//    handleClickOutside(event: any) {
//        if (this._cmpDoMRef && !this._cmpDoMRef.contains(event.target)) {
//            this.setState({
//                holdFocus: false,
//            });
//        }
//        else {
//            this.setState({
//                holdFocus: true,
//            });
//        }
//    }

//    componentWillUnmount() {
//        document.removeEventListener('mousedown', this.handleClickOutside);
//    }

//    componentDidMount() {
//        //(ReactDOM.findDOMNode(this.refs.toggleInput) as HTMLInputElement).bootstrapToggle('on');

//        //var textInput = ReactDOM.findDOMNode(this.refs.toggleInput) as any;
//        //console.log(textInput);
//        //textInput.bootstrapToggle('on');


//        //(ReactDOM.findDOMNode(this.refs.toggleInput)).bootstrapToggle('on');

//        //$(this.refs.toggleInput.getDOMNode()).bootstrapToggle('on');
//        document.addEventListener('mousedown', this.handleClickOutside);
//        TF.DataProcessBinding(this, { type: 'DATA.updateinstrument', fiid: this.state.iheader.fiid, delegate: this.processInstrument });
//        //this.setState({iheader: this.props.iheader});

//        //console.log('DoM.componentDidMount');
//    }


//    _switchCaFilter = (newState: boolean) => {
//        this.setState({ processing: true });

//        let dsFilter: DTO.AgentDSInstrumentFilter = { ...this.props.filterDS, ...{ isContragentLimits: newState }};
//        TF.PublishCommand('COMMAND.State.AgentDSInstrumentFilter', dsFilter);
        
//        return {};
//    }

//    _switchSecFilter = (newState: boolean) => {
//        this.setState({ processing: true });

//        let dsFilter: DTO.AgentDSInstrumentFilter = { ...this.props.filterDS, ...{ isSecuritiesFilters: newState } };
//        TF.PublishCommand('COMMAND.State.AgentDSInstrumentFilter', dsFilter);

//        return {};
//    }
    

//    //getTrProps = {(state, rowInfo) => {
//    //return {
//    //    onClick: (e) => {
//    //        this.setState({
//    //            selected: rowInfo.index
//    //        })
//    //    },
//    //    style: {
//    //        background: rowInfo.index === this.state.selected ? '#00afec' : 'white',
//    //        color: rowInfo.index === this.state.selected ? 'white' : 'black'
//    //    }
//    //}
//    //}

//    nextPath(path: string) {
//        this.props.history.push(path);
//    }

//    updateFilterModal(isVisible: boolean) {
//        this.setState({ isFilterPanelVisible: isVisible})
//        //this.forceUpdate();

//        if (!isVisible) {
//            TF.PublishCommandForceAgentFrame();
//        }
//    }

//    public render() {
//        //console.log(this.state.iheader);
//        let contents = this.state.loading
//            ? <p><em>Processing...</em></p>
//            : this.renderDoMTable(this.state.bookorders, this.state.processing ? this.state.processing : false);

//        //<nav className="navbar navbar-default">
//        //    <div className="container-fluid">
//        //        <div className="navbar-header">
//        //            <a href="#" className="navbar-brand">{this.state.iheader.name}</a>
//        //        </div>
//        //        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-2">
//        //            <form className="navbar-form navbar-left">
//        //                <div className="form-group">
//        //                    <input className="form-control" placeholder="Search" />
//        //                </div>
//        //                <button type="submit" className="btn btn-default">Submit</button>
//        //            </form>
//        //        </div>

//        //    </div>
//        //</nav>


//        //onBlur = { this._onBlur }
//        //onFocus = { this._onFocus }

//        let hdrContent = <div><b>{this.state.iheader.name}</b></div>
//        var wellClass = (this.state.holdFocus ? 'well-selected' : '');
//        var wellTitleClass = 'rep_welltitle';
//        let suspendCover = undefined;
//        if (this.state.iheader.iavail) {
//            if (this.state.iheader.iavail.readonly) {
//                wellTitleClass = wellTitleClass + ' readonly';
//                hdrContent = <div><b>{this.state.iheader.name} {' [ReadOnly]'}</b></div>
//            }
//            if (!this.state.iheader.iavail.suspended && !this.state.iheader.iavail.tradeopen) {
//                wellTitleClass = wellTitleClass + ' passive';
//            }
//            //if (this.state.iheader.iavail.suspended) 
//            //    wellClass = wellClass + ' otc-coverdim';                
//            if (this.state.iheader.iavail.suspended)
//                suspendCover = <div className='otc-coverdim'>
//                    <span>Торги приостановлены</span>
//                </div>
//        }
//        else {
//            wellTitleClass = wellTitleClass + ' passive';
//        }
        
        
//        let fliterContragent = this.props.filterDS.isContragentLimits ?
//            <RB.Button bsStyle="success" title="Лимитный фильтр по контрагентам" onClick={this._switchCaFilter.bind(this, false)} disabled={this.state.processing}>
//                    <RB.Glyphicon glyph="ok" />{" "}{'КА-on'}
//                </RB.Button>
//            :
//            <RB.Button bsStyle="default" title="Лимитный фильтр по контрагентам" onClick={this._switchCaFilter.bind(this, true)} disabled={this.state.processing}>
//                <RB.Glyphicon glyph="minus" />{" "}{'КА-off'}
//                </RB.Button>
//                ;

//        let fliterSecurities = this.props.filterDS.isSecuritiesFilters ?
//            <RB.Button bsStyle="success" title="Лимитный фильтр по ЦБ" onClick={this._switchSecFilter.bind(this, false)}  disabled={this.state.processing}>
//                <RB.Glyphicon glyph="ok" />{" "}{'ЦБ-on'}
//            </RB.Button>
//            :
//            <RB.Button bsStyle="default" title="Лимитный фильтр по ЦБ" onClick={this._switchSecFilter.bind(this, true)}  disabled={this.state.processing}>
//                <RB.Glyphicon glyph="minus" />{" "}{'ЦБ-off'}
//            </RB.Button>
//            ;

//        let filterSettings = <RB.Modal className='menu-sidebar right' style={{ width:'500px' }} show={this.state.isFilterPanelVisible} onHide={() => this.updateFilterModal(false)} autoFocus keyboard>
//            <RB.Modal.Header closeButton>
//                <RB.Modal.Title>{'Настройки фильтров'}</RB.Modal.Title>
//            </RB.Modal.Header>
//            <RB.Modal.Body>
//                <FilterSettings filterDS={this.props.filterDS} xsrfToken={this.props.xsrfToken} {...this.props} {...this.state} />
//            </RB.Modal.Body>
//        </RB.Modal>        

//        let showData = this.state.iheader.iavail ? (this.state.iheader.iavail.tradeopen || this.state.iheader.iavail.suspended ? true : false) : false;

//        let wellFrame = <RB.Well bsSize="sm" className={wellClass} style={{ position: 'relative' }}>
//            {suspendCover}
//            <RB.ButtonToolbar className={wellTitleClass}>
//                <RB.ButtonGroup bsSize="xsmall">
//                    {hdrContent}
//                </RB.ButtonGroup>

//                <RB.ButtonGroup bsSize="xsmall">
//                    <RB.Button title='Настроить фильтры' onClick={() => this.updateFilterModal(true)}><RB.Glyphicon glyph="filter" /></RB.Button>
//                    {showData ? fliterContragent : ''}
//                    {showData ? fliterSecurities : ''}
//                </RB.ButtonGroup>                    
//            </RB.ButtonToolbar>
//            <div>{showData ? contents : <div className='table'></div>}</div>
//        </RB.Well>


//        // onBlur={this._onBlur}
//        //onClick={() => this.nextPath('/settings')}
//        return <div ref={this.setCmpDoMRef}>
//            {filterSettings}
//            <RB.Row>
//                <RB.Col sm={12}>
//                    {wellFrame}
//                </RB.Col>
//            </RB.Row>
//        </div>;

//    }



//    private renderDoMTable(orders: DTO.DomRecord[], processing: boolean) {

        
//        return <table className='table table-header-fixed table-condensed'>
//            <thead>
//                <tr style={{ width: 'calc(100% - 10px)' }}>
//                    <th style={{ textAlign: 'right', width: '20%' }}>BUY</th>
//                    <th style={{ textAlign: 'right', width: '25%' }}>сумма</th>
//                    <th style={{ textAlign: 'right', width: '15%' }}>ставка</th>
//                    <th style={{ textAlign: 'right', width: '25%' }}>сумма</th>
//                    <th style={{ textAlign: 'right', width: '15%' }}>SELL</th>
//                </tr>
//            </thead>
//            <tbody style={{ height: '240px' }}>
//                {orders.map(domrecord =>
//                    <DoMRecordRecord key={domrecord.manipulation.locatorId} record={domrecord} xsrfToken={this.props.xsrfToken} {...initialstate_domrecord} modified={domrecord.manipulation.justChanged ? domrecord.manipulation.justChanged : false}
//                        processing={processing} domrecordSelected={this.handleSelectContext.bind(this)} selected={this.state.selected_locatorId == domrecord.manipulation.locatorId} holdFocus={this.state.holdFocus} />
//                )}
//            </tbody>
//        </table>;
//    }
//}


//type DoMRecordProps = Actions.OrderState & { xsrfToken?: string } & { record: DTO.DomRecord } & { domrecordSelected: any } & { holdFocus: boolean };

//const initialstate_domrecord: Actions.OrderState = {
//    processing: false,
//    haserrors: false,
//    modified: false,
//    selected: false
//}



//class DoMRecordRecord extends React.Component<DoMRecordProps, Actions.OrderState> {
//    constructor(props: DoMRecordProps) {
//        super(props);
//        this.state = {
//            ...initialstate_domrecord, ...{ processing: props.processing, haserrors: props.haserrors, modified: props.modified }
//        };
//    }

//    dispatch = (action: Actions.OrderAction) => {
//        return Dispatch.OrderDispatcher(this, action);
//    }


//    _repeal = (locator: { locatorId: string } | undefined) => {
//        //console.log('_repeal = ');
//        //console.log(locator);

//        let manipulation: DTO.ManipulationAction<string> = {
//            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_LOOKUP,
//            type: DTO.MANIPULATION_PERM_REPEAL,
//            locatorId: locator ? locator.locatorId : undefined,
//            payload: undefined
//        }

//        return Actions.orderActions.modify(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatch);
//    }


//    _onSelectRecord = (locatorId: string, record: DTO.DomRecord) => {
//        return this.props.domrecordSelected(locatorId, record);
//    }


//    componentWillReceiveProps(nextProps: DoMRecordProps) {
//        this.setState(nextProps);
//    }


//    public render() {

//        //let bg_color = this.state.modified ? '#9be8d7' : (this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white'));
//        let bg_color = this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white');
////        let row_border = this.state.selected ? { borderStyle: 'solid', borderWidth: '2.5px' } : { borderStyle: 'none' };

//        let crsr = this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_CONTEXT) ? { cursor: 'pointer' } : {};

//        let animation_mod = this.state.modified ? { animation: 'newdata_blink_green 1s 10' } : {}

//        var trStyle = {
//            //...{ backgroundColor: bg_color }, ...row_border, ...crsr
//            ...{ textAlign: 'right' }, ...{ backgroundColor: bg_color }, ...crsr, ...animation_mod
//        };

//        var trClass: string = (this.props.record.hasownedrecs ? 'owned-recs' : '') + ' ' + (this.state.selected && this.props.holdFocus ? 'rowselected' : (this.state.selected && !this.props.holdFocus ? 'rowonblur' : '')) ;
//        //console.log(trClass);


//        return <tr key={this.props.record.manipulation.locatorId} style={trStyle} onClick={this._onSelectRecord.bind(this, this.props.record.manipulation.locatorId, this.props.record)}
//            className={trClass}>
//            <td style={{ textAlign: 'right', width: '20%' }}>
//                {this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_REPEAL) ?
//                    <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
//                        <RB.Button title='Снять свои заявки' disabled={this.state.processing}
//                            onClick={this._repeal.bind(this, { locatorId: this.props.record.manipulation.locatorId })}><RB.Glyphicon glyph="remove" /></RB.Button>
//                    </RB.ButtonGroup>
//                    : ''
//                }
//                {this.props.record.buylots}
//            </td>
//            <td style={{ textAlign: 'right', width: '25%' }}>{this.props.record.buysum ? <Intl.FormattedNumber value={this.props.record.buysum} minimumFractionDigits={0} maximumFractionDigits={0} /> : ''}</td>
//            <td style={{ textAlign: 'right', width: '15%' }}>{this.props.record.rate ? <Intl.FormattedNumber value={this.props.record.rate / 100.0} style="percent" minimumFractionDigits={2} maximumFractionDigits={2} /> : '-'} </td>            
//            <td style={{ textAlign: 'right', width: '25%' }}>{this.props.record.sellsum ? <Intl.FormattedNumber value={this.props.record.sellsum } minimumFractionDigits={0} maximumFractionDigits={0} /> : ''}</td>
//            <td style={{ textAlign: 'right', width: '15%' }}>{this.props.record.selllots}</td>
//        </tr>
//            ;
//    }

//}

